import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
import withStyles from 'isomorphic-style-loader/withStyles';
import { change } from 'redux-form';
import { connect } from 'react-redux';
import { doRemoveStaticImage, doUploadStaticImage, startStaticImageLoader, stopStaticImageLoader } from '../../../../actions/siteadmin/manageStaticBlock';

import { injectIntl } from 'react-intl';
import { photosShow } from '../../../../helpers/photosShow';

import ImageUploadComponent from '../../ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../../CommonImageDisplay/CommomImageDisplay';
import { homebanneruploadDir } from '../../../../config';
import { withQuery } from '../../../../hoc/withGraphql';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

import cs from '../../../../components/commonStyle.css';
import s from './BlockUploader.css';
import messages from '../../../../locale/jsonMessages';
class BlockUploader extends React.Component {

  static propTypes = {
    staticImageLoading: PropTypes.bool,
    doRemoveStaticImage: PropTypes.any.isRequired,
    getLogoData: PropTypes.shape({
      loading: PropTypes.bool,
      getLogo: PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      })
    })
  };

  static defaultProps = {
    profilePictureData: {
      loading: true
    },
    staticImageLoading: false
  };

  success = async (file, fromServer) => {
    const { doUploadStaticImage, getLogoData: { getStaticInfo }, change, stopStaticImageLoader, startStaticImageLoader, demoRestriction } = this.props;
    let fileName = fromServer.file.filename;
    let oldPicture = getStaticInfo != null ? getStaticInfo[0].value : null;
    let filePath = fromServer.file.path;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    startStaticImageLoader();
    doUploadStaticImage(fileName, filePath, oldPicture, 'carTripImage1');
    await change('StaticBlockForm', 'carTripImage1', fileName);
    stopStaticImageLoader();
  }


  deleteImage = async () => {
    const { doRemoveStaticImage, getLogoData: { getStaticInfo }, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await doRemoveStaticImage(getStaticInfo && getStaticInfo[0].image, 'carTripImage1');
  }

  render() {
    const { getLogoData: { loading, getStaticInfo }, staticImageLoading } = this.props;
    const { formatMessage } = this.props.intl;
    let path = photosShow(homebanneruploadDir);

    return (
      <div>
        <CommonImageDisplay
          loading={loading}
          loader={staticImageLoading}
          image={getStaticInfo && getStaticInfo[0]?.value && path + getStaticInfo[0].value}
          deleteImage={this.deleteImage}
          isDefaultPic={getStaticInfo && getStaticInfo[0]?.value ? false : true}
          isDelete={true}
        />

        <ImageUploadComponent
          defaultMessage={formatMessage(messages.clickHeretoUploadImage)}
          componentConfig={{
            iconFiletypes: ['.jpg', '.png', '.jpeg'],
            multiple: false,
            showFiletypeIcon: false,
            postUrl: '/uploadHomeBanner'
          }}
          loaderName={'staticImageLoading'}
          success={this.success}
          className={cs.spaceTop3}
        />
      </div>
    );
  }
}

const mapState = (state) => ({
  staticImageLoading: state.loader.staticImageLoading,
});

const mapDispatch = {
  doRemoveStaticImage,
  doUploadStaticImage,
  startStaticImageLoader,
  stopStaticImageLoader,
  change,
  demoRestriction
};

export default compose(
  injectIntl,
  withStyles(cs, s),
  connect(mapState, mapDispatch),
  withQuery(gql`
  query ($name: String) {
    getStaticInfo(name: $name) {
      name
      value
    }
  }
    `, {
    name: 'getLogoData',
    options: {
      ssr: false,
      variables: {
        name: 'carTripImage1'
      },
    }
  }),
)(BlockUploader);